import {ChangeEvent, FC, useContext} from 'react';
import {twMerge} from 'tailwind-merge';
import {t} from 'ttag';

import DropdownContext from '../../context';

const DrawerSearchField: FC = () => {
    const {searchQuery, setSearchQuery} = useContext(DropdownContext);

    return (
        <input
            aria-label="Search Input"
            className={twMerge(
                'pointer-events-auto mb-1 h-10 w-full rounded border border-grey-600 px-3 outline-none placeholder-shown:truncate',
                'focus-visible:border-blue-400 focus-visible:ring-1 focus-visible:ring-blue-200',
            )}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                setSearchQuery(event.target.value);
            }}
            placeholder={t`Search`}
            value={searchQuery}
        />
    );
};

DrawerSearchField.displayName = 'DrawerSearchField';

export default DrawerSearchField;
